/* Angular + external */
import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  ComponentRef,
  ElementRef,
  EventEmitter,
  HostListener,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  Output,
  QueryList,
  Renderer2,
  SimpleChanges,
  TemplateRef,
  Type,
  ViewChild,
  ViewChildren,
  ViewContainerRef,
} from "@angular/core";
/***********************/
/* BFX */
// multi-asset
import * as CubiqTS from "shared/cubiq-model-multi-asset";
// global-services

import { LoggerService } from "@bfx/logger";
const logger = LoggerService.for(__dirname);

import { Subscription } from "rxjs";
import { NativeDesktopSupport } from "app/bfx-native-desktop/native-desktop-support";
import { ATDLNControlType } from "../data-atdl/enums/atdl-control-type.enum";
// Enum - ATDL
import { ATDLNParameterType } from "../data-atdl/enums/atdl-parameter-type.enum";
// Models - ATDL
import { ATDLDataModel } from "../data-atdl/model/atdl-data.model";
import { ATDLInterfaceAuxiliaryModel } from "../data-atdl/model/atdl-interface-auxiliary.model";
import { ATDLInterfaceControlModel } from "../data-atdl/model/atdl-interface-control.model";
import { ATDLLayoutControlModel } from "../data-atdl/model/atdl-layout-control.model";
import { ATDLParameterDataModel } from "../data-atdl/model/atdl-parameter-data.model";
import { ICDAuxCheckboxModel } from "../data-idc/controls/icd-aux-checkbox.model";
import { ICDBaseModel } from "../data-idc/controls/icd-base.model";
import { ICDSpinnerModel } from "../data-idc/controls/icd-spinner.model";
import { ICDCommandBaseModel } from "../data-idc/coordination/icd-command-base.model";
// Models - ICD
import { ICDResponseBaseModel } from "../data-idc/coordination/icd-response-base.model";
import { ICDTransportModel } from "../data-idc/coordination/icd-transport.model";
import { ICDNAuxMode } from "../data-idc/enums/icd-aux-mode.enum";
import { ICDNCommand } from "../data-idc/enums/icd-command.enum";
import { ICDNResponseCommand } from "../data-idc/enums/icd-response-cmd.enum";
import { OENCommand } from "../data/enums/oe-command.enum";
// Enum
import { OENEntryType } from "../data/enums/oe-entry-type.enum";
import { OENInputControl } from "../data/enums/oe-input-control.enum";
import { OENLockedState } from "../data/enums/oe-locked-state.enum";
import { OENPanel } from "../data/enums/oe-panel.enum";
import { OECommandEventModel } from "../data/models/oe-command-event.model";
import { OEDataModel } from "../data/models/oe-data.model";
import { OEInputModel } from "../data/models/oe-input.model";
import { OEDLoadingDataModel } from "../data/models/oe-loading-data.model";
import {
  OEInputLockStateItemModel,
  OELockingProfileTransportModel,
} from "../data/models/oe-locking-profile.model";
import { OEAdapterForwardService } from "../services/adapter/oe-adapter-forward.service";
import { OEAdapterReverseService } from "../services/adapter/oe-adapter-reverse.service";
import { ATDLDatasetService } from "../services/atdl/atdl-dataset.service";
import { ATDLUtilityService } from "../services/atdl/atdl-utility.service";
import { ATDLValidatorService } from "../services/atdl/atdl-validator.service";
import { OELoggerService } from "../services/basic/oe-logger.service";
import { OELookupService } from "../services/basic/oe-lookup.service";
import { OEUtilityService } from "../services/basic/oe-utility.service";
import { OEApiService } from "../services/oe-api.service";
// Services
import { OECoordinatorService } from "../services/oe-coordinator.service";
// Components
import { ICAutocompleteGenericModel } from "./controls/models/bfx-interface-controls.models";
import { ICLimitPriceModel } from "./controls/models/ic-limit-price.model";
import { ICDAmountSpinnerComponent } from "./dynamic-controls/icd-amount-spinner.component";
import { ICDAutocompleteComponent } from "./dynamic-controls/icd-autocomplete.component";
import { ICDBase } from "./dynamic-controls/icd-base.component";
import { ICDCheckboxComponent } from "./dynamic-controls/icd-checkbox.component";
import { ICDClockComponent } from "./dynamic-controls/icd-clock.component";
import { ICDIntegerSpinnerComponent } from "./dynamic-controls/icd-integer-spinner.component";
import { ICDLabelComponent } from "./dynamic-controls/icd-label.component";
import { ICDPercentSpinnerComponent } from "./dynamic-controls/icd-percent-spinner.component";
import { ICDCRadioButtonComponent } from "./dynamic-controls/icd-radio-button.component";
import { ICDRateSpinnerComponent } from "./dynamic-controls/icd-rate-spinner.component";
import { ICDTextFieldComponent } from "./dynamic-controls/icd-text-field.component";
import { ICDUnsupportedComponent } from "./dynamic-controls/icd-unsupported.component";
import { OENOperationMode } from "../data/enums/oe-operation-mode.enum";
import { runDetached } from "../../../shared/helper-services/run-detached";
import { ATDLValidationGroupModel } from "app/order-entry/data-atdl/model/atdl-validation-group.model";
import { NullProtoObject } from "../../../shared/helper-services/null-proto-object";
import {
  CCY_CODE,
  ORDER_AMT,
  CCY_PAIR_CODE,
  CCY_PAIR_INVERTED,
  RATE,
  ICD_ID_LIMIT_PRICE,
} from "./oe-panel-algo-params.const";

const PREFERRED_PARAMETERS_HEIGHT: number = 243;

@Component({
  selector: "oe-panel-algo-params",
  templateUrl: "./html/oe-panel-algo-params.html",
  standalone: false,
})
export class OEAlgoParamsComponent implements OnDestroy, OnInit, OnChanges, AfterViewInit {
  @Input() refId: string;
  @Input() rootRefId: string; // refId of the root order
  @Input() entryType: OENEntryType;
  @Input() algoType: ICAutocompleteGenericModel;
  @Input() operationMode: OENOperationMode;

  // external dependencies
  @Input() ccyCode: string = null;
  @Input() ccyPairCode: string = null;
  @Input() ccyPairInverted: boolean = null;

  private _limitPrice: ICLimitPriceModel = null;
  pendingScrollInView: OEInputModel;

  /** Pending param loading model to be applied after algo type has been successsfully changed e.g. an external change of both algo type and param values */
  private pendingLoadingModel: { algoId: string; loadingModel: OEDLoadingDataModel };

  public get limitPrice(): ICLimitPriceModel {
    return this._limitPrice;
  }

  @Input()
  public set limitPrice(value: ICLimitPriceModel) {
    this._limitPrice = value;
  }

  @Output()
  limitPriceChange: EventEmitter<ICLimitPriceModel> = new EventEmitter();

  private _rate: CubiqTS.BigNumber = null;

  public get rate(): CubiqTS.BigNumber {
    return this._rate;
  }

  @Input()
  public set rate(value: CubiqTS.BigNumber) {
    this._rate = value;

    this.processRateChanges();
  }

  @Input() orderAmt: CubiqTS.BigNumber = null;

  @Input() public suppressWindowResizeUpdates: boolean = false;
  @Input() public scrollMaxHeight: number = PREFERRED_PARAMETERS_HEIGHT;
  @Input() public strategyParameters: Array<CubiqTS.StrategyParameterImpl>;

  @Input() public limitPriceContainer: TemplateRef<any>;

  public algoId: string = null;
  public dataModel: ATDLDataModel = null;
  public partFilled: boolean = false;
  ///
  private controlsMap: NullProtoObject = Object.create(null);
  private embeddedControlMap: NullProtoObject = Object.create(null);
  private controlSubscriptionMap: Map<string, Subscription> = new Map();
  /** subscriptions */
  private coordinatorSubscription: Subscription;
  /** cmd buffer - for commands that arrive from the coordinator while initializing or loading */
  private coordinatorCmdBuffer: Array<OECommandEventModel> = new Array<OECommandEventModel>();
  /** icd response buffer - for responses that arrive from the ICDs while initializing or loading */
  private icdResponseBuffer: Map<string, ICDResponseBaseModel> = new Map();
  /** contains mapping of all dependents on a particular value ie. value -> array of ids where to forward */
  private dependencyMap: object = {}; // icd: string => Array<string>
  /** contains mapping of the ICDs that have enabled AUX */
  private auxRefMap: object = {}; // auxId: string => icdID: string
  /** holds icdIds of controls that need a new rate when its available*/
  private ratePending: Array<string> = [];
  /** if rate is unrequested (e.g. duplicate) don't provide rate */
  private rateDependencyActive: Set<string> = new Set();
  //private controlsMetaMap:  Object = new Object();
  private validationScheduled: boolean = false;
  /** state of the panel*/
  public isInitializing: boolean = true;
  public isInitializingEmbedded: boolean = false;
  private isLoading: boolean = false;
  public isLoadingScreen: boolean = false;
  // time based loading fallback
  private loadTimestamp: number = null;
  private loadIdleOffset: number = 3 * 1000; // 3 sec fallback if the load is idle
  // Used to determine initialization end
  private icdsSize: number = 0;
  private icdLoadSize: number = 0;
  private icdsInitialized: number = 0;
  private icdsLoaded: number = 0;
  /// DEV TEST
  private atdl_control_validation_state: boolean = true;
  // ERROR
  public fatalError: boolean = false;
  // Change detection
  private oldCcyCode: string = null;
  private oldCcyPairCode: string = null;
  private oldCcyPairInverted: boolean = null;
  // Scrollbar
  public scrollbarConfig: {
    suppressScrollX: true; // false is default
    suppressScrollY: false; // false is default
  };

  public windowHeight: number;
  // LOCKING
  private lockProfileValue: OENLockedState = OENLockedState.UNLOCKED;
  private lockAllFg: boolean = false;
  protected entryModel: OEDataModel = null;

  @ViewChildren("algoParamsContainer", { read: ViewContainerRef })
  containerRef: QueryList<ViewContainerRef>;

  /**********************************************************************/
  /* OUTPUT  */

  @Output("error") errorChange: EventEmitter<boolean> = new EventEmitter<boolean>();

  @ViewChild("outerContainer")
  private _outerContainer: ElementRef;

  public get outerContainer(): ElementRef {
    return this._outerContainer;
  }
  public set outerContainer(value: ElementRef) {
    this._outerContainer = value;
    if (value != null && this.pendingScrollInView) {
      this.handleScrollInView(this.pendingScrollInView);
      this.pendingScrollInView = null;
    }
  }

  /**********************************************************************/
  /* CONSTRUCTOR  */
  constructor(
    protected oeLogger: OELoggerService,
    private coordinator: OECoordinatorService,
    private api: OEApiService,
    private reverseAdapter: OEAdapterReverseService,
    protected forwardAdapter: OEAdapterForwardService,
    private utilityService: OEUtilityService,
    private lookup: OELookupService,
    public renderer2: Renderer2,
    public cd: ChangeDetectorRef,
    private atdlDataset: ATDLDatasetService,
    private atdlValidator: ATDLValidatorService,
    private atdlUtility: ATDLUtilityService,
    private el: ElementRef,
  ) {
    this.oeLogger = oeLogger.for(__dirname);
  }

  /**********************************************************************/
  /* LIFE CYCLE HOOKS */

  ngOnInit() {
    this.getWindowHeight();
  }

  ngOnDestroy() {
    this.coordinatorSubscription.unsubscribe();
  }

  ngOnChanges(changes: SimpleChanges) {
    for (let propName in changes) {
      switch (propName) {
        // External dependency
        case CCY_CODE:
          this.outputExtendedLogging(`PANEL: CCY Code: `, this.ccyCode);
          this.processCcyCodeChanges();
          break;
        // External dependency
        case ORDER_AMT:
          this.outputExtendedLogging(`PANEL: Order Amount: `, this.orderAmt);
          this.processOrderAmountChanges();
          break;
        // External dependency
        case CCY_PAIR_CODE:
          const all =
            typeof changes?.[CCY_PAIR_CODE].previousValue === "string" &&
            typeof changes?.[CCY_PAIR_CODE].currentValue === "string" &&
            changes?.[CCY_PAIR_CODE].currentValue.length === 6;

          this.processCcyPairCodeChanges(false, all);
          break;
        case CCY_PAIR_INVERTED: // same dependency with
          this.processCcyPairInvertedChanges();
          break;
        // External dependency
        case RATE:
          //this.processCcyPairInvertedChanges();
          this.outputExtendedLogging(`PANEL: Received rate: `, this.rate);
          // FXBFXOM-7150
          // this.processRateChanges();
          break;
        case "entryType":
          if (this.entryType !== OENEntryType.ALGO && this.entryType !== OENEntryType.NDF_ALGO) {
            logger.out.error(
              `ERROR: oeAlgoParamsPanel.ngOnChanges('entryType'): ` +
                `Trying to change the entryType for AlgoParams to ${this.entryType}.`,
            );
          } else {
            for (let key of Object.keys(this.controlsMap)) {
              this.issueICDCommand(key, ICDNCommand.UPDATE_ENTRY_TYPE, this.entryType);
            }
          }
          break;
        case "algoType":
          if (
            this.algoType instanceof ICAutocompleteGenericModel &&
            typeof this.algoType.value === "string" &&
            this.algoType.value.length > 0
          ) {
            if (
              this.dataModel == null ||
              (this.dataModel instanceof ATDLDataModel && this.algoType.value !== this.dataModel.id)
            ) {
              this.dataModel = this.atdlDataset.get(this.algoType.value);
              if (this.dataModel instanceof ATDLDataModel) {
                this.isInitializing = this.strategyParameters == null;
                this.isInitializingEmbedded = this.strategyParameters != null;
                this.algoId = this.algoType.value;

                // update master dataset model
                if (this.strategyParameters == null) {
                  this.updateAlgoParametersInApi();
                }

                this.reInitialize();

                setTimeout(
                  () => {
                    this.createAlgoControlsStructure();
                    this.loadStrategyParametersInput();
                  },
                  this.strategyParameters != null ? 0 : 100,
                );

                this.outputExtendedLogging(
                  `ALGO: PANEL -> Changed to model for ${this.algoType.value} dump:`,
                  this.dataModel,
                );
              } else {
                logger.out.error(
                  `ERROR: oeAlgoParamsPanel.ngOnChanges('algoType'): ${this.algoType.value} not found!`,
                );
                this.cleanupAlgoOnError();
              }
            } else {
              // to be deleted
              this.outputExtendedLogging(
                `ALGO: PANEL -> Change has no effect, same model! id: ${this.algoType.value} === modelID: ${this.dataModel.id}`,
              );
            }
          } else if (
            this.algoType == null ||
            (this.algoType instanceof ICAutocompleteGenericModel &&
              (this.algoType.value == null || this.algoType.value === ""))
          ) {
            this.reset();
          } else {
            logger.out.error(
              `ERROR: oeAlgoParamsPanel.ngOnChanges('algoType'): Error while trying to change strategy definition model for '${this.algoType}'`,
            );
          }
          break;
      }
    }
  }

  /**
   * Allowq this to be reset externally - when embedded in a dialog it can be displayed mutliple times so need to clear
   * the models between invocations
   */
  public reset() {
    this.algoType = null;
    this.dataModel = null;
    this.algoId = null;
    this.cleanupAllInterfaceControls();
    logger.out.info(`INFO: oeAlgoParamsPanel.ngOnChanges('algoType'): Model set to NULL!`);
  }

  /**
   * Use for BM Algo strategy parameter edit in the hedge order monitor, or when processing an external
   * change to an Algo type
   */
  protected loadStrategyParametersInput(): void {
    let loadingModel: OEDLoadingDataModel;
    if (this.pendingLoadingModel) {
      // When algo type has been set we may have pending parameter values to be applied from a loading model
      if (this.pendingLoadingModel.algoId === this.algoId) {
        // Get the saved values,
        loadingModel = this.pendingLoadingModel.loadingModel;
        this.applyLoadingModelToAlgoValues(loadingModel);
        this.updateLocking();
      }
      this.pendingLoadingModel = null;
    } else if (this.strategyParameters != null) {
      this.createLocalDataModel();
      this.loadInitialStrategyParameters();
    }
  }

  /**
   * Create an order data model managed locally
   */
  protected createLocalDataModel() {
    let model: OEDataModel = new OEDataModel();

    model.entryType = this.entryType;
    model.algoType = this.algoType;

    model.ccyPair = this.ccyPairCode;
    if (this.ccyPairCode != null) {
      model.ccyPairModel = this.lookup.ccyPair(this.ccyPairCode);
    }
    this.entryModel = model;
    // Ensure strategy parameters are defined correctly on the model
    this.reverseAdapter.parseStrategyParameters(
      this.entryModel,
      this.dataModel,
      this.strategyParameters,
    );
  }

  /**
   * Create a loading model from entry model created from parameters
   */
  private loadInitialStrategyParameters() {
    let loadingModel: OEDLoadingDataModel =
      this.utilityService.createInterfaceLoadDataForAlgoParameters(this.entryModel);
    this.applyLoadingModelToAlgoValues(loadingModel);
  }

  /**
   * Apply loading model to all parameters controls
   */
  private applyLoadingModelToAlgoValues(loadingModel: OEDLoadingDataModel) {
    let cmd: OECommandEventModel = new OECommandEventModel(
      null,
      OENCommand.LOAD_CONTROLS,
      loadingModel,
    );
    cmd.ref = this.refId;

    loadingModel.algoValues.forEach((algoValue: OEInputModel) => {
      if (algoValue.value != null && algoValue.value.value instanceof ICDSpinnerModel) {
        let spinnerModel: ICDSpinnerModel = algoValue.value.value;
        spinnerModel.skipInitValue = spinnerModel.value == null;
      }
    });

    if (this.isInitializing || this.isLoading) {
      // push to buffer
      this.coordinatorCmdBuffer.push(cmd);
    } else {
      this.processCoordinatorCmd(cmd);
    }
  }

  private processCcyCodeChanges(override: boolean = false): void {
    if (typeof this.ccyCode === "string" && (this.ccyPairCode !== this.oldCcyCode || override)) {
      this.oldCcyCode = this.ccyCode;
      if (
        this.dependencyMap[CCY_CODE] instanceof Array &&
        this.dependencyMap[CCY_CODE].length > 0
      ) {
        for (let icdId of this.dependencyMap[CCY_CODE]) {
          if (Object.hasOwn(this.controlsMap, icdId)) {
            this.issueICDCommand(icdId, ICDNCommand.UPDATE_CONSTRAINT, {
              name: CCY_CODE,
              value: this.ccyCode,
            });
          }
        }
      }
    }
  }

  private processOrderAmountChanges(): void {
    if (this.orderAmt instanceof CubiqTS.BigNumber || this.orderAmt == null) {
      if (
        this.dependencyMap[ORDER_AMT] instanceof Array &&
        this.dependencyMap[ORDER_AMT].length > 0
      ) {
        for (let icdId of this.dependencyMap[ORDER_AMT]) {
          if (Object.hasOwn(this.controlsMap, icdId)) {
            this.issueICDCommand(icdId, ICDNCommand.UPDATE_CONSTRAINT, {
              name: ORDER_AMT,
              value: this.orderAmt,
            });
          }
        }
      }
    }
  }

  private processCcyPairCodeChanges(override: boolean = false, all = true): void {
    if (
      typeof this.ccyPairCode === "string" &&
      (this.ccyPairCode !== this.oldCcyPairCode || override)
    ) {
      this.oldCcyPairCode = this.ccyPairCode;
      this.ratePending = [...(all ? this.dependencyMap[RATE] : this.rateDependencyActive.values())];
      if (
        this.dependencyMap[CCY_PAIR_CODE] instanceof Array &&
        this.dependencyMap[CCY_PAIR_CODE].length > 0
      ) {
        for (let icdId of this.dependencyMap[CCY_PAIR_CODE]) {
          if (Object.hasOwn(this.controlsMap, icdId)) {
            this.issueICDCommand(icdId, ICDNCommand.UPDATE_CONSTRAINT, {
              name: CCY_PAIR_CODE,
              value: this.ccyPairCode,
            });
          }
        }
      }
    } else if (this.ccyPairCode == null && this.oldCcyPairCode != null) {
      this.oldCcyPairCode = null;
      this.ratePending = [];
    }
  }

  private processCcyPairInvertedChanges(override: boolean = false): void {
    if (
      typeof this.ccyPairInverted === "boolean" &&
      (this.ccyPairInverted !== this.oldCcyPairInverted || override)
    ) {
      this.oldCcyPairInverted = this.ccyPairInverted;
      if (
        this.dependencyMap[CCY_PAIR_CODE] instanceof Array &&
        this.dependencyMap[CCY_PAIR_CODE].length > 0
      ) {
        for (let icdId of this.dependencyMap[CCY_PAIR_CODE]) {
          if (Object.hasOwn(this.controlsMap, icdId)) {
            this.issueICDCommand(icdId, ICDNCommand.UPDATE_CONSTRAINT, {
              name: CCY_PAIR_INVERTED,
              value: this.ccyPairInverted,
            });
          }
        }
      }
    }
  }

  private processRateChanges(): void {
    if (this.rate instanceof CubiqTS.BigNumber) {
      if (Array.isArray(this.ratePending) && Array.isArray(this.dependencyMap[RATE])) {
        for (let icdId of this.ratePending) {
          if (Object.hasOwn(this.controlsMap, icdId) && this.dependencyMap[RATE].includes(icdId)) {
            this.issueICDCommand(icdId, ICDNCommand.UPDATE_CONSTRAINT, {
              name: RATE,
              value: this.rate,
            });
            this.rateDependencyActive.add(icdId);
          }
        }
        this.ratePending = [];
      }
    }
  }

  protected updateAlgoParameterValue(parameterName: string, parameterValue: any): void {
    let param: ATDLParameterDataModel = this.entryModel?.algoParameters.find(
      (model: ATDLParameterDataModel) => model.refName == parameterName,
    );
    if (param != null) {
      param.value = parameterValue;
    }
  }

  public updateStrategyParameters(): boolean {
    let errors: OEInputModel[] = [];

    this.forwardAdapter.processAlgoParameters(this.entryModel, this.strategyParameters, errors);

    errors.forEach((data, i) => {
      if (i == 0) {
        this.handleScrollInView(data);
      }
      this.handleInvalidInput(data);
    });
    return errors.length == 0;
  }

  ngAfterViewInit() {
    this.initialize();
  }

  /**
   * Works on browser. On desktop gets triggered on main window resize, but has no effect, so all good.
   * Could be refactored for improved performance on desktop, but it will be negligible improvement.
   */
  @HostListener("window:resize")
  getWindowHeight(): void {
    if (!NativeDesktopSupport.isNativeDesktopContainer() && !this.suppressWindowResizeUpdates) {
      let mxH = PREFERRED_PARAMETERS_HEIGHT;
      if (window.innerHeight < 665) {
        mxH = 50;
      } else if (window.innerHeight < 715) {
        mxH = 100;
      } else if (window.innerHeight < 765) {
        mxH = 150;
      } else if (window.innerHeight < 815) {
        mxH = 150;
      }
      this.scrollMaxHeight = mxH;
    }
  }

  /**********************************************************************/
  /* INITIALIZATION */

  public initialize(): void {
    this.subscribeToCoordinator();
    this.reInitDependencyMap();
    this.partFilled = this.entryModelPartFilled();
  }

  protected reInitialize(): void {
    this.fatalError = false;
    this.icdsInitialized = 0;
    this.icdsLoaded = 0;
    this.partFilled = this.entryModelPartFilled();

    this.cleanupAllInterfaceControls();

    // re-init maps
    this.reInitDependencyMap();
    this.reInitAuxRefMap();
  }

  private reInitDependencyMap(): void {
    this.dependencyMap = new Object();
    // create external dependencies
    this.dependencyMap[CCY_CODE] = new Array<string>();
    this.dependencyMap[CCY_PAIR_CODE] = new Array<string>();
    this.dependencyMap[RATE] = new Array<string>();
    this.dependencyMap[ORDER_AMT] = new Array<string>();
  }

  private reInitAuxRefMap(): void {
    this.auxRefMap = new Object();
    // Limit price - split brain - add auxMap reference if needed
    let limitPriceControl = this.dataModel.controls.find(
      (item) => item.icdId.toLowerCase() === ICD_ID_LIMIT_PRICE,
    );
    if (
      limitPriceControl instanceof ATDLInterfaceControlModel &&
      limitPriceControl.auxiliary instanceof Array &&
      limitPriceControl.auxiliary[0] instanceof ATDLInterfaceAuxiliaryModel &&
      limitPriceControl.auxiliary[0].icdType === ATDLNControlType.CHECKBOX
    ) {
      this.auxRefMap[limitPriceControl.auxiliary[0].icdId] = limitPriceControl.icdId;
    }
  }
  /**********************************************************************/
  /* ALGO ENTRY API */
  public isReady(): boolean {
    return !(
      this.isInitializing ||
      this.isInitializingEmbedded ||
      this.isLoading ||
      this.isLoadingScreen
    );
  }

  /**********************************************************************/
  /* COORDINATOR HANDLER */
  private subscribeToCoordinator(): void {
    this.coordinatorSubscription = this.coordinator.algoPanelCmd$
      .pipe(runDetached(this))
      .subscribe(($event: OECommandEventModel) => {
        if ($event.ref === this.refId) {
          if (this.isInitializing || this.isLoading) {
            // push to buffer
            this.coordinatorCmdBuffer.push($event);
          } else {
            this.processCoordinatorCmd($event);
          }
        }
      });
  }

  private processCoordinatorCmd($event: OECommandEventModel) {
    if ($event instanceof OECommandEventModel) {
      if ($event.ref === this.refId) {
        switch ($event.cmd) {
          case OENCommand.RESET_ALL:
            this.resetAll();
            break;
          case OENCommand.INVALID_INPUT:
            this.handleInvalidInput($event.data);
            break;
          case OENCommand.SCROLL_IN_VIEW:
            this.handleScrollInView($event.data);
            break;
          case OENCommand.LOCK_ALL:
            this.lockAll();
            break;
          case OENCommand.UNLOCK_ALL:
            this.unlockAll();
            break;
          case OENCommand.LOAD_LOCKING_PROFILE:
            this.loadLockProfile($event.data);
            break;
          case OENCommand.LOAD_CONTROLS:
            this.loadAll($event.data);
            if (!this.isLoading) {
              this.pushAllControlValues();
            }
            break;
          case OENCommand.ATDL_CONTROL_VALIDATION:
            if ($event instanceof OECommandEventModel && typeof $event.data === "boolean") {
              this.atdl_control_validation_state = $event.data;
              this.updateAtdlControlValidationState();
            }
            break;
          case OENCommand.VALIDATE:
            logger.out.error("not implemented");
            break;
          case OENCommand.UNBULK:
          case OENCommand.BULKED:
          case OENCommand.BULKING:
            break;
          case OENCommand.CONTROL_LOADING_COMPLETE:
            this.initialiseLimitPrice();
            break;
          default:
            logger.out.error(
              `ERROR: oeAlgoParamPanel.subscribeToCoordinator(): Command not implemented! command= (${
                $event.cmd
              }) [${$event.cmd != null ? OENCommand[$event.cmd] : "NULL"}]`,
            );
            break;
        }
      }
    }
  }

  private emptyCoordinatorCmdBuffer(): void {
    if (this.coordinatorCmdBuffer instanceof Array && this.coordinatorCmdBuffer.length > 0) {
      do {
        this.processCoordinatorCmd(this.coordinatorCmdBuffer.shift());
      } while (this.coordinatorCmdBuffer.length > 0);
    }
  }

  private doesCoordinatorBufferHasLoadCmd(): boolean {
    if (this.coordinatorCmdBuffer instanceof Array && this.coordinatorCmdBuffer.length > 0) {
      return (
        this.coordinatorCmdBuffer.find((item) => item.cmd === OENCommand.LOAD_CONTROLS) != null
      );
    }
    return false;
  }

  private applyLoadFromCoordinatorCmdBuffer(): void {
    if (this.doesCoordinatorBufferHasLoadCmd()) {
      let loadCmdIndex = this.coordinatorCmdBuffer.indexOf(
        this.coordinatorCmdBuffer.find((item) => item.cmd === OENCommand.LOAD_CONTROLS),
      );
      let loadCmdArray = this.coordinatorCmdBuffer.splice(loadCmdIndex, 1);
      if (
        loadCmdArray instanceof Array &&
        loadCmdArray[0] instanceof OECommandEventModel &&
        loadCmdArray[0].cmd === OENCommand.LOAD_CONTROLS
      ) {
        this.processCoordinatorCmd(loadCmdArray[0]);
      } else {
        logger.out.error(
          `ERROR: oeAlgoParamPanel.applyLoadFromCoordinatorCmdBuffer(): Error while extracting Load command from the buffer`,
        );
      }
    } else {
      logger.out.warn(
        `WARNING: oeAlgoParamPanel.applyLoadFromCoordinatorCmdBuffer(): Load command not found in Coordinator Cmd Buffer => Aborting Load`,
      );
    }
  }

  /**********************************************************************/
  /* METHODS */
  private updateAtdlControlValidationState(): void {
    for (let key of Object.keys(this.controlsMap)) {
      this.issueICDCommand(
        key,
        ICDNCommand.ATDL_CONTROL_VALIDATION,
        this.atdl_control_validation_state,
      );
    }
  }

  private loadAll(loadModel: OEDLoadingDataModel): void {
    if (
      loadModel instanceof OEDLoadingDataModel &&
      loadModel.algoValues instanceof Array &&
      loadModel.algoValues.length > 0
    ) {
      const algoValue = loadModel.values.find((value) => value.input === OENInputControl.ALGO_TYPE);
      const algoId = algoValue?.value?.value;
      if (algoId && algoId !== this.algoId) {
        // If there's an algo type and it doesn't match then set aside the parameters to be loaded later
        this.pendingLoadingModel = { algoId, loadingModel: loadModel };
      } else {
        //this.loadTimestamp = parseInt(CubiqTS.moment().format('x'));
        setTimeout(() => {
          if (this.isLoading) {
            this.handleLoadComplete(null, true);
          }
        }, this.loadIdleOffset);
        this.icdLoadSize = this.calculateNumberOfControlsToLoad(loadModel.algoValues);
        for (let icdLoadModel of loadModel.algoValues) {
          if (
            icdLoadModel.value instanceof ICDTransportModel &&
            Object.hasOwn(this.controlsMap, icdLoadModel.value.icdId)
          ) {
            this.issueICDCommand(icdLoadModel.value.icdId, ICDNCommand.LOAD, {
              value: icdLoadModel.value.value,
              propagate: false,
            });
          }
        }
      }
    }
  }

  private resetAll(): void {
    // local reset
    this.icdsInitialized = 0;
    this.icdsLoaded = 0;
    // re-init maps
    this.reInitDependencyMap();
    this.reInitAuxRefMap();
    //
    for (let key of Object.keys(this.controlsMap)) {
      this.issueICDCommand(key, ICDNCommand.RESET_AND_INIT);
    }
  }

  protected loadLockProfile(lockingProfile: OELockingProfileTransportModel): void {
    if (
      lockingProfile instanceof OELockingProfileTransportModel &&
      Array.isArray(lockingProfile.profile) &&
      lockingProfile.profile.length > 0
    ) {
      let lockItem: OEInputLockStateItemModel = lockingProfile.profile.find(
        (item) => item.panel === OENPanel.PANEL_ALGO && item.input === OENInputControl._ALGO_,
      );
      if (lockItem instanceof OEInputLockStateItemModel) {
        if (lockItem.lockState !== OENLockedState.NONE) {
          this.lockProfileValue = lockItem.lockState;
          this.updateLocking();
        }
      }
    } else {
      logger.out.warn(`WARNING: oeAlgoParamPanel.loadLockProfile(): Invalid locking profile`);
    }
  }

  private lockAll(): void {
    this.lockAllFg = true;
    this.updateLocking();
  }

  private unlockAll(): void {
    this.lockAllFg = false;
    this.updateLocking();
  }

  private updateLocking(): void {
    let lockCMDValue: ICDNCommand = null;
    if (!this.lockAllFg) {
      // lockAll is INACTIVE
      if (this.lockProfileValue === OENLockedState.LOCKED) {
        lockCMDValue = ICDNCommand.LOCK;
      } else if (this.lockProfileValue === OENLockedState.UNLOCKED) {
        lockCMDValue = ICDNCommand.UNLOCK;
      }
    } else {
      lockCMDValue = ICDNCommand.LOCK;
    }

    // send command
    if (lockCMDValue != null) {
      for (let key of Object.keys(this.controlsMap)) {
        this.issueICDCommand(key, lockCMDValue);
      }
    }
  }

  private handleInvalidInput(data: OEInputModel): void {
    if (data instanceof OEInputModel && data.value instanceof ICDTransportModel) {
      if (Object.hasOwn(this.controlsMap, data.value.icdId)) {
        this.issueICDCommand(data.value.icdId, ICDNCommand.INVALID_INPUT, data.value);
      } else {
        logger.out.error(
          `ERROR: oeAlgoParamPanel.handleInvalidInput(): Control [${data.value.icdId}] NOT FOUND`,
        );
      }
    } else {
      logger.out.error(`ERROR: oeAlgoParamPanel.handleInvalidInput(): Invalid data model %O`, data);
    }
  }

  private handleScrollInView(data: OEInputModel): void {
    if (this.outerContainer == null) {
      this.pendingScrollInView = data;
      return;
    }

    if (data instanceof OEInputModel && data.value instanceof ICDTransportModel) {
      if (Object.hasOwn(this.controlsMap, data.value.icdId)) {
        this.issueICDCommand(data.value.icdId, ICDNCommand.SCROLL_IN_VIEW, {
          container: this.outerContainer?.nativeElement,
        });
      } else {
        logger.out.error(
          `ERROR: oeAlgoParamPanel.handleInvalidInput(): Control [${data.value.icdId}] NOT FOUND`,
        );
      }
    } else {
      logger.out.error(`ERROR: oeAlgoParamPanel.handleInvalidInput(): Invalid data model %O`, data);
    }
  }
  /**********************************************************************/
  /* Dynamic Injection of IDCs*/

  protected createAlgoControlsStructure(): void {
    if (
      this.dataModel instanceof ATDLDataModel &&
      this.dataModel.layoutStructure instanceof Array
    ) {
      this.icdsSize = this.calculateNumberOfControls();
      this.dataModel.layoutStructure.forEach((row: Array<ATDLLayoutControlModel>) => {
        for (let icd of row) {
          let model = this.getInterfaceControlModel(icd.icdId);
          if (model instanceof ATDLInterfaceControlModel && this.selectAndInjectICDComponent(icd)) {
            this.initializeIDCAttachSubscription(icd.icdId, model);
            this.outputExtendedLogging(
              `INFO: oeAlgoParamPanel.createAlgoControlsStructure(): ICD Control '${icd.refName}' INITIALIZED`,
            ); // with model: %O`, model);
          } else {
            this.cleanupAlgoOnError();
          }
        }
      });
    }
  }

  private selectAndInjectICDComponent(icdLayout: ATDLLayoutControlModel): boolean {
    if (icdLayout instanceof ATDLLayoutControlModel) {
      let error: boolean = false;

      switch (icdLayout.icdType) {
        case ATDLNControlType.DROPDOWN_LIST:
          this.controlsMap[icdLayout.icdId] =
            this.injectICDComponent<ICDAutocompleteComponent>(ICDAutocompleteComponent);
          this.outputExtendedLogging(
            `INFO: oeAlgoParamPanel.selectAndInjectICDComponent(): ICD control [${
              icdLayout.icdId
            }] of type ${ATDLNControlType[icdLayout.icdType]} INJECTED`,
          );
          break;
        case ATDLNControlType.CHECKBOX:
          this.controlsMap[icdLayout.icdId] =
            this.injectICDComponent<ICDCheckboxComponent>(ICDCheckboxComponent);
          this.outputExtendedLogging(
            `INFO: oeAlgoParamPanel.selectAndInjectICDComponent(): ICD control [${
              icdLayout.icdId
            }] of type ${ATDLNControlType[icdLayout.icdType]} INJECTED`,
          );
          break;
        case ATDLNControlType.LABEL:
          if (
            icdLayout.paramType !== ATDLNParameterType.BOOLEAN_FIX &&
            icdLayout.paramType !== ATDLNParameterType.STRING &&
            icdLayout.paramType !== ATDLNParameterType.CHAR
          ) {
            this.outputExtendedLogging(
              `INFO: oeAlgoParamPanel.selectAndInjectICDComponent(): ICD control [${
                icdLayout.icdId
              }] of type ${ATDLNControlType[icdLayout.icdType]} has invalid param type ${
                ATDLNControlType[icdLayout.icdType]
              }`,
            );
          }
          this.controlsMap[icdLayout.icdId] =
            this.injectICDComponent<ICDLabelComponent>(ICDLabelComponent);
          this.outputExtendedLogging(
            `INFO: oeAlgoParamPanel.selectAndInjectICDComponent(): ICD control [${
              icdLayout.icdId
            }] of type ${ATDLNControlType[icdLayout.icdType]} INJECTED`,
          );
          break;
        case ATDLNControlType.SINGLE_SPINNER:
          switch (icdLayout.paramType) {
            case ATDLNParameterType.PRICE:
              if (icdLayout.icdId.toLowerCase() === ICD_ID_LIMIT_PRICE) {
                if (!this.dependencyMap[RATE].includes(icdLayout.icdId))
                  this.dependencyMap[RATE].push(icdLayout.icdId);
              }
            case ATDLNParameterType.PRICE_OFFSET:
            case ATDLNParameterType.FLOAT:
              this.controlsMap[icdLayout.icdId] =
                this.injectICDComponent<ICDRateSpinnerComponent>(ICDRateSpinnerComponent);
              this.dependencyMap[CCY_PAIR_CODE].push(icdLayout.icdId);
              break;
            case ATDLNParameterType.AMT:
            case ATDLNParameterType.QTY:
              this.controlsMap[icdLayout.icdId] =
                this.injectICDComponent<ICDAmountSpinnerComponent>(ICDAmountSpinnerComponent);
              this.dependencyMap[CCY_CODE].push(icdLayout.icdId);
              if (icdLayout.paramType === ATDLNParameterType.AMT) {
                this.dependencyMap[ORDER_AMT].push(icdLayout.icdId);
              }
              break;
            case ATDLNParameterType.PERCENT:
              this.controlsMap[icdLayout.icdId] =
                this.injectICDComponent<ICDPercentSpinnerComponent>(ICDPercentSpinnerComponent);
              break;
            case ATDLNParameterType.INT:
              this.controlsMap[icdLayout.icdId] =
                this.injectICDComponent<ICDIntegerSpinnerComponent>(ICDIntegerSpinnerComponent);
              break;
            default:
              this.controlsMap[icdLayout.icdId] =
                this.injectICDComponent<ICDUnsupportedComponent>(ICDUnsupportedComponent);
              logger.out.error(
                `ERROR: oeAlgoParamPanel.selectAndInjectICDComponent(): Unknown ${
                  ATDLNControlType[icdLayout.icdType]
                } of sub-type:  ${ATDLNParameterType[icdLayout.paramType]} for ${icdLayout.icdId}`,
              );
              break;
          }
          if (!error) {
            this.outputExtendedLogging(
              `INFO: oeAlgoParamPanel.selectAndInjectICDComponent(): ICD control [${
                icdLayout.icdId
              }] of type ${ATDLNControlType[icdLayout.icdType]}: ${
                ATDLNParameterType[icdLayout.paramType]
              } INJECTED`,
            );
          }
          break;
        case ATDLNControlType.TEXTFIELD:
          this.controlsMap[icdLayout.icdId] =
            this.injectICDComponent<ICDTextFieldComponent>(ICDTextFieldComponent);
          this.outputExtendedLogging(
            `INFO: oeAlgoParamPanel.selectAndInjectICDComponent(): ICD control [${
              icdLayout.icdId
            }] of type ${ATDLNControlType[icdLayout.icdType]} INJECTED`,
          );
          break;
        case ATDLNControlType.CLOCK:
          this.controlsMap[icdLayout.icdId] =
            this.injectICDComponent<ICDClockComponent>(ICDClockComponent);
          this.outputExtendedLogging(
            `INFO: oeAlgoParamPanel.selectAndInjectICDComponent(): ICD control [${
              icdLayout.icdId
            }] of type ${ATDLNControlType[icdLayout.icdType]} INJECTED`,
          );
          break;
        case ATDLNControlType.RADIO_LIST:
          this.controlsMap[icdLayout.icdId] =
            this.injectICDComponent<ICDCRadioButtonComponent>(ICDCRadioButtonComponent);
          this.outputExtendedLogging(
            `INFO: oeAlgoParamPanel.selectAndInjectICDComponent(): ICD control [${
              icdLayout.icdId
            }] of type ${ATDLNControlType[icdLayout.icdType]} INJECTED`,
          );
          break;
        case ATDLNControlType.CHECKBOX_LIST:
        case ATDLNControlType.HIDDEN:
        case ATDLNControlType.MULTI_SELECT_LIST:
        case ATDLNControlType.SINGLE_SELECT_LIST:
        case ATDLNControlType.SLIDER:
        case ATDLNControlType.UNSUPPORTED:
          this.controlsMap[icdLayout.icdId] =
            this.injectICDComponent<ICDUnsupportedComponent>(ICDUnsupportedComponent);
          logger.out.warn(
            `WARNING: oeAlgoParamPanel.selectAndInjectICDComponent(): ICD control [${
              icdLayout.icdId
            }] with UNSUPPORTED type of ${ATDLNControlType[icdLayout.icdType]}`,
          );
          break;
        default:
          error = true;
          logger.out.error(
            `ERROR: oeAlgoParamPanel.selectAndInjectICDComponent(): ICD control [${icdLayout.icdId}] with UNKNOWN type ${icdLayout.icdType}`,
          );
          break;
      }
      return !error;
    } else {
      logger.out.error(
        `ERROR: oeAlgoParamPanel.selectAndInjectICDComponent(): Row ICD data is INVALID %O`,
        icdLayout,
      );
      return false;
    }
  }

  private injectICDComponent<T extends ICDBase<ICDBaseModel>>(icdInput: Type<T>): ComponentRef<T> {
    let index: number = null;
    for (let i = 0; i < this.containerRef.toArray().length; i++) {
      if (
        index === null &&
        this.containerRef.toArray()[i].element.nativeElement.previousElementSibling == null
      ) {
        index = i;
      }
    }

    let singleContainerRef = index != null ? this.containerRef.toArray()[index] : null;

    if (singleContainerRef != null) {
      const component = singleContainerRef.createComponent(icdInput);
      return component;
    } else {
      this.outputExtendedLogging("singleContainerRef is NULL");
    }
  }

  private injectEmbeddedView(icdId: string, ref: TemplateRef<any>): void {
    let index: number = null;
    for (let i = 0; i < this.containerRef.toArray().length; i++) {
      if (
        index === null &&
        this.containerRef.toArray()[i].element.nativeElement.previousElementSibling == null
      ) {
        index = i;
      }
    }

    let singleContainerRef = index != null ? this.containerRef.toArray()[index] : null;

    if (singleContainerRef != null) {
      const embeddedView = singleContainerRef.createEmbeddedView(ref);
      this.controlsMap[icdId] = embeddedView;
      this.embeddedControlMap[icdId] = embeddedView;
      // embedded controls are dealt with by parent entry component
      // so flag initialization and load as done
      this.handleInitializationComplete(icdId);
      this.handleLoadComplete(icdId);
    } else {
      this.outputExtendedLogging("singleContainerRef is NULL");
    }
  }

  private initializeIDCAttachSubscription(_icdId: string, model: ATDLInterfaceControlModel): void {
    if (this.controlsMap[_icdId] instanceof ComponentRef) {
      this.controlSubscriptionMap.set(
        _icdId,
        this.controlsMap[_icdId].instance
          .dynInitializeSubscription()
          .subscribe((responseData: ICDResponseBaseModel) => {
            this.handleResponse(responseData);
          }),
      );
      this.controlsMap[_icdId].instance.dynInitializeModel(model);
    } else {
      // ignoring embedded view
    }
  }

  protected cleanupAllInterfaceControls(): void {
    for (let icdId of Object.keys(this.controlsMap)) {
      this.outputExtendedLogging(`ALGO: PANEL -> cleanup interface control ${icdId}`);
      if (this.controlSubscriptionMap.has(icdId)) {
        this.controlSubscriptionMap.get(icdId).unsubscribe();
        this.controlSubscriptionMap.delete(icdId);
      }
      if (this.controlsMap[icdId] != null) {
        this.controlsMap[icdId]?.destroy?.();
        delete this.controlsMap[icdId];
      }
    }
  }

  private cleanupAlgoOnError(): void {
    this.cleanupAllInterfaceControls();
    this.fatalError = true;
    this.atdlDataset.delete(this.algoId);
    this.errorChange.emit(true);
  }

  /**********************************************************************/
  /* IDC Coordination */
  private issueICDCommand(icdId: string, command: ICDNCommand, data?: any): void {
    if (
      this.isICDIdValid(icdId) &&
      this.controlsMap[icdId] instanceof ComponentRef &&
      typeof command === "number"
    ) {
      switch (command) {
        case ICDNCommand.LOCK:
        case ICDNCommand.UNLOCK:
        case ICDNCommand.RESET:
        case ICDNCommand.VALIDATE:
        case ICDNCommand.FOCUS_INPUT:
        case ICDNCommand.ENABLE:
        case ICDNCommand.DISABLE:
        case ICDNCommand.LOADING_START:
        case ICDNCommand.LOADING_END:
        case ICDNCommand.INITIALIZING_START:
        case ICDNCommand.INITIALIZING_END:
        case ICDNCommand.SCROLL_IN_VIEW:
          this.controlsMap[icdId].instance.dynCommand(
            new ICDCommandBaseModel(icdId, command, data),
          );
          break;
        case ICDNCommand.UPDATE_ENTRY_TYPE:
          this.controlsMap[icdId].instance.dynCommand(
            new ICDCommandBaseModel(icdId, command, this.entryType),
          );
          break;
        case ICDNCommand.UPDATE_CONSTRAINT:
          if (data) {
            // Let receiver perform a data model test when more than one fields are references
            data.testEditRuleCondition = this.testEditRuleCondition.bind(this);
          }
          this.controlsMap[icdId].instance.dynCommand(
            new ICDCommandBaseModel(icdId, command, data != null ? data : null),
          );
          break;
        case ICDNCommand.RESET_AND_INIT:
        case ICDNCommand.LOAD:
        case ICDNCommand.UPDATE_AUX_MODEL:
        case ICDNCommand.INVALID_INPUT:
        case ICDNCommand.ATDL_CONTROL_VALIDATION:
        case ICDNCommand.UPDATE_PART_FILL_STATE:
        case ICDNCommand.PUSH_VALUE:
          this.controlsMap[icdId].instance.dynCommand(
            new ICDCommandBaseModel(icdId, command, data != null ? data : null),
          );
          break;
        case ICDNCommand.UPDATE_VALIDATION: //data is optional
          if (data == null) {
            data = this.dataModel.controls.find((item) => item.icdId === icdId);
          }

          if (data instanceof ATDLInterfaceControlModel) {
            this.controlsMap[icdId].instance.dynCommand(
              new ICDCommandBaseModel(icdId, command, data),
            );
          } else {
            logger.out.error(
              `ERROR: oeAlgoParamsPanel.issueICDCommand(): Could not find interface control model for '${icdId}'`,
            );
          }
          break;
        default:
          logger.out.error(
            `ERROR: oeAlgoParamsPanel.issueICDCommand(): Unsupported command ${command}`,
          );
          break;
      }
    } else if (Object.hasOwn(this.embeddedControlMap, icdId)) {
      // ignoring Embedded Control (e.g. Limit Price)
    } else {
      logger.out.error(
        `ERROR: oeAlgoParamsPanel.issueICDCommand(): Received invalid icdId '${icdId}'or component ref is missing %O`,
        this.controlsMap[icdId],
      );
    }
  }

  private handleResponse(response: ICDResponseBaseModel): void {
    if (response instanceof ICDResponseBaseModel) {
      if (this.isICDIdValid(response.icdId)) {
        if (response.data != null) {
          this.outputExtendedLogging(
            `PANEL: Received [${response.icdId}] => Command ${
              ICDNResponseCommand[response.responseCmd]
            } | data %O`,
            response.data,
          );
        } else {
          this.outputExtendedLogging(
            `PANEL: Received [${response.icdId}] => Command ${
              ICDNResponseCommand[response.responseCmd]
            }`,
          );
        }

        switch (response.responseCmd) {
          case ICDNResponseCommand.INITIALIZATION_ERROR:
            this.cleanupAlgoOnError();
            break;
          case ICDNResponseCommand.INITIALIZATION_COMPLETE:
            this.handleInitializationComplete(response.icdId);
            break;
          case ICDNResponseCommand.LOAD_COMPLETE:
            this.handleLoadComplete(response.icdId);
            break;
          case ICDNResponseCommand.UPDATE_VALUE:
            this.handleIcdValueUpdate(response);
            break;
          case ICDNResponseCommand.PERFORM_VALIDATION:
            if (this.atdl_control_validation_state && !this.isInitializing && !this.isLoading) {
              this.handleValidationRequest();
            }
            break;
          case ICDNResponseCommand.UPDATE_VISIBILITY:
            this.handleICDVisibilityUpdate(response);
            break;
          case ICDNResponseCommand.REGISTER_AUX_REF:
            this.handleRegisterAuxRef(response);
            break;
          case ICDNResponseCommand.REGISTER_DEPENDENCY:
            this.handleRegisterDependency(response);
            break;
          case ICDNResponseCommand.REQUEST_RATE:
            this.ratePending.push(response.icdId);
            setTimeout(() => {
              if (this.rate != null) {
                this.issueICDCommand(response.icdId, ICDNCommand.UPDATE_CONSTRAINT, {
                  name: RATE,
                  value: this.rate,
                });
              } else {
                this.ratePending.push(response.icdId);
              }
              this.rateDependencyActive.add(response.icdId);
            }, 0);
            break;
          case ICDNResponseCommand.RESET_ACK:
            // do nothing for now
            break;
          default:
            logger.out.error(
              `ERROR: oeAlgoParamsPanel.handleResponse(): Unknown ICDNResponseCommand`,
            );
            break;
        }
      } else {
        logger.out.error(
          `ERROR: oeAlgoParamsPanel.handleResponse(): Received invalid icdId '${response.icdId}'or component ref is missing %O`,
          this.controlsMap[response.icdId],
        );
      }
    } else {
      logger.out.error(
        `ERROR: oeAlgoParamsPanel.handleResponse(): Received invalid response from component! %O`,
        response,
      );
    }
  }

  /**********************************************************************/
  /* ICD Response Handlers */

  private handleIcdValueUpdate(response: ICDResponseBaseModel): void {
    if (response instanceof ICDResponseBaseModel) {
      if (this.isInitializing || this.isLoading) {
        this.icdResponseBuffer.set(response.icdId, response);
      } else {
        this.processIDCValueUpdate(response);
      }
    }
  }

  /**
   * re-orders issue of update to ensure any dependent CONSTRAINT_UPDATE apply first
   */
  private flushIcdResponseBuffer(): void {
    const a = [];

    for (let [icdId, response] of this.icdResponseBuffer.entries()) {
      const dependencies = Array.isArray(this.dependencyMap[icdId])
        ? this.dependencyMap[icdId]
        : [];

      if (a.some(([icdId]) => dependencies.includes(icdId))) {
        a.unshift([icdId, response]);
      } else {
        a.push([icdId, response]);
      }
    }

    this.icdResponseBuffer.clear();

    for (let [_, response] of a) {
      this.processIDCValueUpdate(response);
    }
  }

  /**
   * Reapply the stored limit price back to the comtrols - this should update limit price models
   * after loading is completed. This gets around model-blocking behaviour when modifying after
   * controls have already beein created
   */
  private initialiseLimitPrice(): void {
    let limitControl = this.dataModel.controls.find(
      (item) => item.icdId.toLowerCase() === ICD_ID_LIMIT_PRICE,
    );
    if (limitControl) {
      const controlId = limitControl.icdId;
      if (Object.hasOwn(this.controlsMap, controlId)) {
        this.issueICDCommand(controlId, ICDNCommand.PUSH_VALUE, limitControl.value);
      }
    }
  }

  private processIDCValueUpdate(response: ICDResponseBaseModel): void {
    try {
      // update controls model
      let icdId = response.icdId;
      let control = this.dataModel.controls.find((item) => item.icdId === icdId);
      if (control instanceof ATDLInterfaceControlModel) {
        let icdValue = response.data;
        let auxId = null;
        let auxValue = null;

        if (response.data instanceof ICDBaseModel) {
          icdValue = this.atdlUtility.getValueFromICDBaseModel(response.data);
          auxId = response.data.auxModel != null ? response.data.auxModel.auxId : null;
          auxValue = response.data.auxModel;
        }
        // update dependents on ICD
        if (this.dependencyMap[icdId] instanceof Array && this.dependencyMap[icdId].length > 0) {
          for (let target of this.dependencyMap[icdId]) {
            let targetIcdId: string = null;
            // if target is aux
            if (
              this.auxRefMap.hasOwnProperty(target) &&
              typeof this.auxRefMap[target] === "string"
            ) {
              targetIcdId = this.auxRefMap[target];
            } else {
              targetIcdId = target;
            }
            //
            if (Object.hasOwn(this.controlsMap, targetIcdId)) {
              this.outputExtendedLogging(
                `SATE FLOW: forwarded value from ICD (${icdId}) to ICD ${targetIcdId}  | value: O%`,
                icdValue,
              );
              this.issueICDCommand(targetIcdId, ICDNCommand.UPDATE_CONSTRAINT, {
                name: icdId,
                value: icdValue,
              });
            } else {
              logger.out.error(
                `ERROR: oeAlgoParamsPanel.handleUpdateValue(): TARGET control [${targetIcdId}] NOT FOUND`,
              );
            }
          }
        }
        // update dependents on AUX
        if (
          auxId != null &&
          this.dependencyMap[auxId] instanceof Array &&
          this.dependencyMap[auxId].length > 0
        ) {
          for (let target of this.dependencyMap[auxId]) {
            let targetIcdId: string = null;
            // if target is aux
            if (
              this.auxRefMap.hasOwnProperty(target) &&
              typeof this.auxRefMap[target] === "string"
            ) {
              targetIcdId = this.auxRefMap[target];
            } else {
              targetIcdId = target;
            }
            if (Object.hasOwn(this.controlsMap, targetIcdId)) {
              this.outputExtendedLogging(
                `SATE FLOW: forwarded value from AUX (${auxId}) to ICD ${targetIcdId} | value: O%`,
                auxValue,
              );
              this.issueICDCommand(targetIcdId, ICDNCommand.UPDATE_CONSTRAINT, {
                name: auxId,
                value: auxValue,
              });
            } else {
              logger.out.error(
                `ERROR: oeAlgoParamsPanel.handleUpdateValue(): TARGET control [${targetIcdId}] NOT FOUND`,
              );
            }
          }
        }
        if (icdId.toLowerCase() === ICD_ID_LIMIT_PRICE) {
          const activated = typeof auxValue?.value == "boolean" ? auxValue.value : false;
          let mode: ICDNAuxMode = auxValue?.mode != null ? auxValue.mode : null;
          if (auxValue != null && auxValue.auxId == null) {
            logger.out.info(
              `${this.constructor.name}: No aux control for limit price, proceeding with algo price setting`,
            );

            try {
              if (control?.refName != null && Array.isArray(this.dataModel?.parameters)) {
                let lpParam: ATDLParameterDataModel = null;
                lpParam = this.dataModel.parameters.find((p) => p.refName === control.refName);
                if (lpParam != null && lpParam.required === true) {
                  mode = ICDNAuxMode.REQUIRED;
                  logger.out.info(
                    `${this.constructor.name}: ${lpParam.refName} is required, setting limit price mode to required`,
                  );
                }
              }
            } catch (ex) {
              logger.out.error(
                `${this.constructor.name}: Failed to assign algo price setting for limit price to limit price control mode. ${ex}`,
              );
            }
          }

          const model =
            this.limitPrice != null
              ? Object.assign(new ICLimitPriceModel(), this.limitPrice)
              : new ICLimitPriceModel();
          model.value = icdValue;
          if (model.value != null && model.value instanceof CubiqTS.BigNumber) {
            model.textValue = model.value.toString();
          } else {
            model.textValue = "";
          }

          model.activated = activated;
          model.mode = mode;

          this._limitPrice = model;
          this.limitPriceChange.next(this.limitPrice);
        }
      } else {
        logger.out.error(
          `ERROR: oeAlgoParamsPanel.handleUpdateValue(): ORIGIN control [${icdId}] NOT FOUND`,
        );
      }
      // update parameter on the oe master data model
      // This will only update the nulledByDependencyOf the input model...
      if (control instanceof ATDLInterfaceControlModel && typeof control.refName === "string") {
        let parameter = this.dataModel.parameters.find((item) => item.icdId === response.icdId);
        if (parameter instanceof ATDLParameterDataModel) {
          if (!parameter.disableValueUpdate) {
            parameter.value = response.data;

            if (this.strategyParameters != null) {
              this.updateAlgoParameterValue(parameter.refName, parameter.value);
            } else {
              this.updateAlgoParameterInApi(parameter);
            }
          }
        } else {
          logger.out.error(
            `ERROR: oeAlgoParamsPanel.handleUpdateValue(): PARAMETER ${response.icdId} NOT FOUND`,
          );
        }
      }
    } catch (ex) {
      logger.out.error(`ERROR: oeAlgoParamsPanel.handleUpdateValue(): Exception: %O`, ex);
    }
  }

  private handleInitializationComplete(icdId: string): void {
    if (Object.hasOwn(this.controlsMap, icdId)) {
      this.icdsInitialized++;

      if (
        (this.isInitializing || this.strategyParameters != null) &&
        this.icdsInitialized >= this.icdsSize
      ) {
        this.isInitializing = false;
        setTimeout(
          (() => {
            this.isInitializingEmbedded = false;
          }).bind(this),
          500,
        );

        if (this.doesCoordinatorBufferHasLoadCmd()) {
          // if load command is in the buffer
          this.isLoading = true;
          this.isLoadingScreen = true;
          setTimeout(() => {
            for (let key of Object.keys(this.controlsMap)) {
              this.issueICDCommand(key, ICDNCommand.LOADING_START);
            }
          }, 50);

          setTimeout(() => {
            this.applyLoadFromCoordinatorCmdBuffer();
            this.pushAllControlValues();
          }, 100);
        } else {
          // no loading command
          setTimeout(() => {
            this.updateAtdlControlValidationState(); // DEV -TEST
            for (let key of Object.keys(this.controlsMap)) {
              this.issueICDCommand(key, ICDNCommand.INITIALIZING_END);
              this.pushAllControlValues();
            }
          }, 50);

          // apply external dependency values
          setTimeout(() => {
            this.updateFillState();
            this.processCcyPairCodeChanges(true, false);
            this.processCcyPairInvertedChanges(true);
            this.processRateChanges();
          }, 150);

          // apply all coordinator commands that were receive while initialization
          setTimeout(() => {
            this.emptyCoordinatorCmdBuffer();
          }, 250);
        }
      }
    }
  }

  private handleLoadComplete(icdId: string, forceComplete: boolean = false): void {
    if (Object.hasOwn(this.controlsMap, icdId) || forceComplete) {
      this.icdsLoaded++;
      // loading time-based fallback
      /* let currentTimestamp = parseInt(CubiqTS.moment().format('x'));
			let loadIdleLimitReached = typeof this.loadTimestamp === 'number' 
										&& currentTimestamp >= (this.loadTimestamp + this.loadIdleOffset); */
      //
      //logger.out.warn(`ALGO-LOAD: icdId: ${icdId} | isLoading: ${this.isLoading} | IC Loaded: ${this.icdsLoaded} | IC Total: ${this.icdLoadSize} | IC All done: ${this.icdsLoaded >= this.icdsSize} | Force: ${forceComplete}`);
      if (this.isLoading && (this.icdsLoaded >= this.icdLoadSize || forceComplete)) {
        if (forceComplete) {
          logger.out.warn(
            `WARN: Algo panel loading time limit reached, force complete loading procedure!`,
          );
        }

        setTimeout(() => {
          this.updateAtdlControlValidationState(); // DEV -TEST
          for (let key of Object.keys(this.controlsMap)) {
            this.issueICDCommand(key, ICDNCommand.LOADING_END);
          }
        }, 50);

        // apply external dependency values
        setTimeout(() => {
          this.updateFillState();
          this.flushIcdResponseBuffer();
          this.processCcyPairCodeChanges(true, false);
          this.processCcyPairInvertedChanges(true);
          this.processRateChanges();
        }, 150);

        // apply all coordinator commands that were received while initialization
        setTimeout(() => {
          this.isLoading = false;
          this.flushIcdResponseBuffer();
          this.performATDLValidation();
          this.emptyCoordinatorCmdBuffer();
        }, 250);

        setTimeout(() => {
          this.isLoadingScreen = false;
        }, 350);
      }
    }
  }

  /**
   * Push all values out as events to ensure state rulesa are primed from final values
   */
  private pushAllControlValues(): void {
    for (let key of Object.keys(this.controlsMap)) {
      this.issueICDCommand(key, ICDNCommand.PUSH_VALUE);
    }
  }
  private updateFillState(): void {
    for (let icdId of Object.keys(this.controlsMap)) {
      // update parameter
      let parameterModel = this.dataModel.parameters.find((item) => item.icdId === icdId);
      if (parameterModel instanceof ATDLParameterDataModel && this.partFilled) {
        parameterModel.disableValueUpdate = parameterModel.disableOnPartFill;
      }
      this.issueICDCommand(icdId, ICDNCommand.UPDATE_PART_FILL_STATE, this.partFilled);
    }
  }

  private calculateNumberOfControls(): number {
    let result: number = 0;
    for (let row of this.dataModel.layoutStructure) {
      for (let control of row) {
        if (typeof control.refName === "string") {
          result++;
        }
      }
    }
    return result;
  }

  private calculateNumberOfControlsToLoad(loadData: Array<OEInputModel>): number {
    let result: number = 0;
    if (Array.isArray(loadData) && loadData.length > 0) {
      for (let loadItem of loadData) {
        if (
          loadItem.value instanceof ICDTransportModel &&
          typeof loadItem.value.icdId === "string"
        ) {
          result++;
        }
      }
    }
    return result;
  }

  private handleValidationRequest(): void {
    if (!this.validationScheduled) {
      this.validationScheduled = true;
      setTimeout(() => {
        this.performATDLValidation();
      }, 200);
    }
  }

  private performATDLValidation(): void {
    try {
      let affectedControls: Set<string> = this.atdlValidator.validateModel(this.dataModel);
      this.outputExtendedLogging(
        `PANEL: Validation Affected controls: ${
          affectedControls instanceof Set && affectedControls.size > 0 ? affectedControls : "NONE"
        }`,
      );
      if (affectedControls instanceof Set && affectedControls.size > 0) {
        for (let icdId of affectedControls) {
          if (Object.hasOwn(this.controlsMap, icdId)) {
            let control = this.dataModel.controls.find((item) => item.icdId === icdId);
            if (control instanceof ATDLInterfaceControlModel) {
              this.issueICDCommand(icdId, ICDNCommand.UPDATE_VALIDATION, control);
            } else {
              logger.out.error(
                `ERROR: oeAlgoParamsPanel.handleIDCPerformValidation(): Control not found [${icdId}]`,
              );
            }
          }
        }
      }
      this.validationScheduled = false;
    } catch (ex) {
      logger.out.error(`ERROR: oeAlgoParamsPanel.handleIDCPerformValidation(): Exception: %O`, ex);
    }
  }

  private handleICDVisibilityUpdate(response: ICDResponseBaseModel): void {
    try {
      if (response instanceof ICDResponseBaseModel && typeof response.data === "boolean") {
        let visibilityChangeApplied: boolean = false;
        for (let row of this.dataModel.layoutStructure) {
          let layoutControl = row.find((item: ATDLLayoutControlModel) => {
            return item.icdId === response.icdId;
          });
          if (layoutControl instanceof ATDLLayoutControlModel) {
            layoutControl.visible = response.data;
            visibilityChangeApplied = true;
          }
        }
      } else {
        logger.out.error(
          `ERROR: oeAlgoParamsPanel.handleICDVisibilityUpdate(): Invalid response model %O`,
          response,
        );
      }
    } catch (ex) {
      logger.out.error(`ERROR: oeAlgoParamsPanel.handleICDVisibilityUpdate(): Exception: %O`, ex);
    }
  }

  private handleRegisterAuxRef(response: ICDResponseBaseModel): void {
    try {
      let icdId: string = response != null ? response.icdId : null;
      let auxId: string = response != null ? response.data : null;

      if (
        response instanceof ICDResponseBaseModel &&
        typeof icdId === "string" &&
        typeof auxId === "string"
      ) {
        if (Object.hasOwn(this.controlsMap, icdId)) {
          this.auxRefMap[auxId] = icdId;
          this.outputExtendedLogging(`Registered AUX (${auxId}) is attached on ICD ${icdId}`);
        } else {
          logger.out.error(
            `ERROR: oeAlgoParamsPanel.handleRegisterAuxRef(): Control ${icdId} NOT FOUND`,
          );
        }
      } else {
        logger.out.error(
          `ERROR: oeAlgoParamsPanel.handleRegisterAuxRef(): Invalid response model %O`,
          response,
        );
      }
    } catch (ex) {
      logger.out.error(`ERROR: oeAlgoParamsPanel.handleRegisterAuxRef(): Exception: %O`, ex);
    }
  }

  private handleRegisterDependency(response: ICDResponseBaseModel): void {
    try {
      let icdId: string = response != null ? response.icdId : null;
      let depId: string = response != null ? response.data : null;
      let auxId: string = null;

      if (
        response.data instanceof Object &&
        response.data.hasOwnProperty("auxId") &&
        response.data.hasOwnProperty("depId")
      ) {
        depId = response.data.depId;
        auxId = response.data.auxId;
      }

      if (
        response instanceof ICDResponseBaseModel &&
        typeof icdId === "string" &&
        typeof depId === "string"
      ) {
        //if(Object.hasOwn(this.controlsMap, depId) && Object.hasOwn(this.controlsMap, icdId)){
        if (!this.dependencyMap.hasOwnProperty(depId)) {
          this.dependencyMap[depId] = new Array<string>();
        }

        if (typeof auxId === "string") {
          if (!this.dependencyMap[depId].includes(auxId)) {
            this.dependencyMap[depId].push(auxId);
            this.outputExtendedLogging(
              `Registered AUX (${auxId}) dependency on ${depId} => [${this.dependencyMap[
                depId
              ].toString()}]`,
            );
          } else {
            // dev-test
            this.outputExtendedLogging(
              `Already registered AUX (${auxId}) dependency on ${depId} => [${this.dependencyMap[
                depId
              ].toString()}]`,
            );
          }
        } else {
          if (!this.dependencyMap[depId].includes(icdId)) {
            this.dependencyMap[depId].push(icdId);
            this.outputExtendedLogging(
              `Registered ICD (${icdId}) dependency on ${depId} => [${this.dependencyMap[
                depId
              ].toString()}]`,
            );
          } else {
            // dev-test
            this.outputExtendedLogging(
              `Already registered ICD (${icdId}) dependency on ${depId} => [${this.dependencyMap[
                depId
              ].toString()}]`,
            );
          }
        }
        /* }else{
					logger.out.error(`ERROR: oeAlgoParamsPanel.handleRegisterDependency(): Control ${depId} (ORIGIN) or  ${response.icdId} (target) NOT FOUND`);
				} */
      } else {
        logger.out.error(
          `ERROR: oeAlgoParamsPanel.handleRegisterDependency(): Invalid response model %O`,
          response,
        );
      }
    } catch (ex) {
      logger.out.error(`ERROR: oeAlgoParamsPanel.handleRegisterDependency(): Exception: %O`, ex);
    }
  }

  /**********************************************************************/
  /* ICD ID - Management */

  private getInterfaceControlModel(icdId: string): ATDLInterfaceControlModel {
    if (typeof icdId === "string") {
      let targetControl: ATDLInterfaceControlModel = this.dataModel.controls.find(
        (item) => item.icdId === icdId,
      );
      return targetControl instanceof ATDLInterfaceControlModel ? targetControl : null;
    }
    return null;
  }

  private isICDIdValid(icdId: string): boolean {
    return typeof icdId === "string" && icdId.length > 4 && Object.hasOwn(this.controlsMap, icdId);
  }

  /**
   * Method passed to components so they can validate logicOperator StateRules that require knowledge
   * of full data model
   * @param rule
   * @returns
   */
  private testEditRuleCondition(rule: ATDLValidationGroupModel): boolean {
    return this.atdlValidator.validateSingleControlFlowModel(this.dataModel, rule);
  }

  /******************************/
  // API Interface methods than should be overridden if component is used without an OE Data Model

  /**
   * Push defined strategy parameters into the OE Data Model
   */
  protected updateAlgoParametersInApi() {
    this.api.setAlgoParameters(this.refId, this.algoId, this.dataModel.parameters);
  }

  /**
   * Is the top-level order part-filled?
   * @returns
   */
  protected entryModelPartFilled(): boolean {
    return this.api.hasBeenPartiallyFilled(this.refId);
  }

  /**
   * Push any parameter update out to the top-level order data model
   * @param parameter
   */
  protected updateAlgoParameterInApi(parameter: ATDLParameterDataModel) {
    this.api.updateAlgoParameterValue(this.refId, this.algoId, parameter.refName, parameter.value);
  }

  /**********************************************************************/
  /* DEBUG - HELPER  */

  protected outputExtendedLogging(value: string, dump: any = null): void {
    this.oeLogger.outputExtendedLogging(value, dump);
  }
}
